import React from 'react'
import Grid from '@mui/material/Grid'
import Stack from '@mui/material/Stack'
import useMediaQuery from '@mui/material/useMediaQuery'
import { Theme, useTheme } from '@mui/material/styles'
import { Drawer, Paper, Toolbar } from '@mui/material'

import ExpertisesTable from './containers/ExpertisesTable'
import ExpertisesSearchForm from './containers/ExpertisesSearchForm'
import PageContainer from '@/components/ui/containers/PageContainer'
import ExpertisesSearchFormMobileContainer from './containers/ExpertisesSearchFormMobile'
import ExpertisesCardViewContainer from './containers/ExpertisesCardViews'
import { CreateExpertiseButton } from './components/CreateExpertiseButton'

const sidebarWidth = 300

type ExpertisesPageProps = {}

const ExpertisesPage = (props: ExpertisesPageProps) => {
  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'))
  const isLargeScreen = useMediaQuery(theme.breakpoints.up('lg'))

  return (
    <PageContainer>
      <Grid container>
        {!isMobile && isLargeScreen && (
          <Grid item>
            <Drawer
              variant="permanent"
              sx={{
                width: sidebarWidth,
                flexShrink: 0,
                [`& .MuiDrawer-paper`]: {
                  width: sidebarWidth,
                  boxSizing: 'border-box',
                  pb: '20px',
                  [theme.breakpoints.up('md')]: {
                    position: 'absolute',
                  },
                },
              }}
            >
              <Toolbar />
              <ExpertisesSearchForm />
            </Drawer>
          </Grid>
        )}
        <Grid item xs={isLargeScreen ? true : 12}>
          <Grid container spacing={2}>
            <Grid container item xs={12} spacing={2}>
              <Grid item xs={12}>
                <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2}>
                  <CreateExpertiseButton />
                </Stack>
              </Grid>
              {!isLargeScreen && (
                <Grid item xs={12} lg={8} xl={9}>
                  <Paper sx={{ mb: '20px', pt: '1px', pb: '15px' }}>
                    {isMobile && <ExpertisesSearchFormMobileContainer />}
                    {!isMobile && <ExpertisesSearchForm />}
                  </Paper>
                </Grid>
              )}
            </Grid>
            <Grid item xs={12}>
              {isMobile ? <ExpertisesCardViewContainer /> : <ExpertisesTable />}
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </PageContainer>
  )
}

export default ExpertisesPage
